import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

const categoryColor: Record<string, string> = {
  活动报道: "bg-secondary-100 text-secondary-800",
  采访专访: "bg-primary-100 text-primary-800",
  作品发布: "bg-accent-100 text-accent-800",
  荣誉奖项: "bg-accent-500 text-foreground-950",
  幕后花絮: "bg-background-200 text-foreground-700",
};

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex flex-col sm:flex-row bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="w-full sm:w-56 h-44 sm:h-auto shrink-0 overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 白石茉莉奈资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 p-4 md:p-5 flex flex-col">
        <div className="flex items-center gap-3 mb-2.5 flex-wrap">
          <span
            className={`text-[11px] font-body px-2.5 py-1 rounded-full ${
              categoryColor[item.category] ?? "bg-background-200 text-foreground-700"
            }`}
          >
            {item.category}
          </span>
          <span className="text-xs text-foreground-400 font-body flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
          <span className="text-xs text-foreground-400 font-body flex items-center gap-1">
            <i className="ri-fire-line"></i>
            {item.views.toLocaleString()}
          </span>
        </div>
        <h3 className="font-heading text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed mt-2.5 line-clamp-2 font-body">
          {item.summary}
        </p>
        <span className="mt-auto pt-3 text-sm text-primary-600 font-body flex items-center gap-1">
          阅读全文
          <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}